import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { DevelopmentRequestService } from '../../service/development-request/development-request.service';
import { DevelopmentRequest } from '../../class/development-request';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { AbstractControl, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SelectItem, DataTable } from 'primeng/primeng';
import { config } from '../../../../../environments/config';
import { formatDate } from '../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../theme/functions/calendarES';

@Component({
  selector: 'app-development-requests',
  templateUrl: './development-requests.component.html',
  styleUrls: ['./development-requests.component.scss']
})
export class DevelopmentRequestsComponent implements OnInit, OnDestroy {

  public promiseForm: Promise<any>;
  public msgs: Message[] = [];
  public developmentRequest: DevelopmentRequest[];
  public selectDevReq: DevelopmentRequest;
  public devReqID: Number = 0;
  public modNew = false;
  public modView = false;
  public openDevReq = false;
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public sort: string;
  public query: string;
  public devReqPosition: string;
  public filters: {key: string, value: string}[];

  public first = 0;

  public showFilter: boolean;

  public form3: FormGroup;
  // public status_filter: AbstractControl;
  // public type_problem_filter: AbstractControl;
  // public department_id_filter: AbstractControl;
  // public priority_filter: AbstractControl;
  // public company_id_filter: AbstractControl;
  // public employee_id_filter: AbstractControl;

  public form4: FormGroup;
  // public f4_date_start: AbstractControl;
  // public f4_date_end: AbstractControl;
  // public f4_venue_id: AbstractControl;
  // public f4_department_id: AbstractControl;
  // public f4_status_filter: AbstractControl;

  public apiUrl = config.API_ROOT;

  public modExportDialog: boolean;

  public statusOptions: SelectItem[];
  public type_problemOptions: SelectItem[];
  public priorityOptions: SelectItem[];

  public pagePath: string;
  public subPagePath: string;

  public myEmployeeId: string;
  public verification: boolean;
  public params_id_dev_req: number;
  public showNewDevReq: boolean;
  public showExportDevReq: boolean;
  public reloadInterval: any;
  public loading: boolean;
  public es: any;

  constructor(
    public DevelopmentRequestService: DevelopmentRequestService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    private route: ActivatedRoute,
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder
  ) {
    this.loading = false;
    this.page = 1;
    this.per_page = 10;
    this.sort = '-id';

    this.es = calendarES();

    this.statusOptions = [
      {label: 'Todos', value: 'all'},
      {label: 'Por hacer', value: 'Por hacer'},
      {label: 'Programado', value: 'Programado'},
      {label: 'En ejecución', value: 'En ejecución'},
      {label: 'Cerrado', value: 'Cerrado'},
      {label: 'No aplica', value: 'No aplica'},
    ];

    // this.type_problemOptions = [
    //   {label: 'Todas', value: 'all'},
    //   {label: 'Queja', value: 'Queja'},
    //   {label: 'No Conforme', value: 'No Conforme'},
    //   {label: 'Solicitud', value: 'Solicitud'},
    //   {label: 'Felicitación', value: 'Felicitación'},
    // ];

    this.priorityOptions = [
      {label: 'Todas', value: 'all'},
      {label: 'Alta', value: 'Alta'},
      {label: 'Media', value: 'Media'},
      {label: 'Baja', value: 'Baja'},
    ];

    // this.form3 = fb.group({
    //   'status_filter': [''],
    //   'type_problem_filter': [''],
    //   'department_id_filter': [''],
    //   'priority_filter': [''],
    //   'company_id_filter': [''],
    //   'employee_id_filter': [''],
    // });

    // this.status_filter = this.form3.controls['status_filter'];
    // // this.type_problem_filter = this.form3.controls['type_problem_filter'];
    // // this.department_id_filter = this.form3.controls['department_id_filter'];
    // this.priority_filter = this.form3.controls['priority_filter'];
    // this.status_filter.setValue('all');
    // // this.type_problem_filter.setValue('all');
    // this.priority_filter.setValue('all');
    // // this.company_id_filter = this.form3.controls['company_id_filter'];
    // // this.employee_id_filter = this.form3.controls['employee_id_filter'];

    // this.form4 = fb.group({
    //   'f4_date_start': ['', [Validators.required]],
    //   'f4_date_end': ['', [Validators.required]],
    //   'f4_venue_id': [''],
    //   'f4_department_id': [''],
    //   'f4_status_filter': [''],
    // });

    // this.f4_date_start = this.form4.controls['f4_date_start'];
    // this.f4_date_end = this.form4.controls['f4_date_end'];
    // this.f4_venue_id = this.form4.controls['f4_venue_id'];
    // this.f4_department_id = this.form4.controls['f4_department_id'];
    // this.f4_status_filter = this.form4.controls['f4_status_filter'];
    // this.f4_status_filter.setValue('all');

    this.modExportDialog = false;

    this.loading = false;

  }

  ngOnInit() {
    this.showFilter = true;

    this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;

    this.filters = [];

    this.createForm3(null);
    this.createForm4(null);
  }

  ngOnDestroy() {
    // Will clear when component is destroyed e.g. route is navigated away from.
    clearInterval(this.reloadInterval);
  }

  public loadDevReqLazy(event: LazyLoadEvent) {
    this.page = (event.first / this.per_page) + 1;
    if (event.sortOrder === -1) {
      this.sort =  '-' + event.sortField;
    } else {
      if (event.sortField) {
        this.sort =  event.sortField;
      } else {
        this.sort = '-id';
      }
    }

    if (event.globalFilter) {
      this.query = event.globalFilter;
    }
    this.getDevReq();
  }

  createForm3(data:any = null){
    data = data || {
      status_filter: '',
      type_problem_filter: '',
      department_id_filter: '',
      priority_filter: '',
      company_id_filter: '',
      employee_id_filter: '',

    };
    this.form3 = this.fb.group({
      status_filter: new FormControl(data.status_filter),
      type_problem_filter: new FormControl(data.type_problem_filter),
      department_id_filter: new FormControl(data.department_id_filter),
      priority_filter: new FormControl(data.status_filter),
      company_id_filter: new FormControl(data.type_problem_filter),
      employee_id_filter: new FormControl(data.department_id_filter),
    });
  }

  createForm4(data:any = null){
    data = data || {
      f4_date_start: '',
      f4_date_end: '',
      f4_venue_id: '',
      f4_department_id: '',
      f4_status_filter: '',
    };
    this.form4 = this.fb.group({

      f4_date_start: new FormControl(data.f4_date_start, Validators.compose([Validators.required])),
      f4_date_end: new FormControl(data.f4_date_end, Validators.compose([Validators.required])),
      f4_venue_id: new FormControl(data.f4_venue_id),
      f4_department_id: new FormControl(data.f4_department_id),
      f4_status_filter: new FormControl(data.f4_status_filter),

    });
  }


  getDevReq() {
    this.loading = true;
    this.DevelopmentRequestService.getDevReq(this.page, this.per_page, this.sort, this.query, this.filters).toPromise().then(
      response => {
        this.loading = false;
        this.developmentRequest = response.json().data;
        if (response.json().meta.total > response.json().meta.total_filtered) {
          this.totalRecords = response.json().meta.total_filtered;
        } else {
          this.totalRecords = response.json().meta.total;
        }
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'No se puede realizar la solicitud' } );
      }
    );
  }

  public edit(devReq: DevelopmentRequest) {
    this.modNew = true;
    this.selectDevReq = devReq;
  }

  public deleteDialog(devReq: DevelopmentRequest) {
    let message;
    this.translate.get('Do you want to delete?').subscribe((res: string) => {
      message = res;
    });

    let header;
    this.translate.get('Delete Confirmation').subscribe((res: string) => {
      header = res;
    });

    this.confirmationService.confirm({
      message: message,
      header: header,
      icon: 'fa fa-trash',
      accept: () => {
        this.delete(devReq);
      }
    });
  }

  public delete(devReq: DevelopmentRequest) {
    this.DevelopmentRequestService.deleteDevReq(devReq.id).toPromise().then(
      response => {
        this.msgs = [];
        this.msgs.push( { severity: 'success', summary: 'Solicitud eliminada' } );
        this.getDevReq();
      },
      error => {
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'Error al eliminar' } );
      }
    );
  }

  public activeDevReq(devReq: DevelopmentRequest) {
    this.putDevReq(devReq);
  }

  public putDevReq(values: DevelopmentRequest) {
    const param = {
      'activated': values.activated
    };
    if (values) {
      const promise = this.DevelopmentRequestService.updateDevReq(values.id, param);
      this.promiseForm = promise.toPromise().then(
        response => {
          this.translate.get('saved').subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push( { severity: 'success', summary: res } );
          });
        },
        error => {
          this.msgs.push( { severity: 'error', summary: 'No se puede actualizar la solicitud' } );
        }
      );
    }
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public hasRole(rol){
    var r: boolean=false;
    var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
    if(role == rol){
      r = true;
    }
    return (r);
  }

  public filter (values?) {
    this.page = 1;
    this.first = 0;

    this.filters = [];

    if (values.status_filter !== 'all' && values.status_filter !== '') {
      this.filters.push({'key': 'status-lk', 'value': values.status_filter});
    }

    if (values.priority_filter !== 'all' && values.priority_filter !== '') {
      this.filters.push({'key': 'priority-lk', 'value': values.priority_filter});
    }

    this.getDevReq();
  }

  getDevReqById(query?: string, filters?: any[]) {
    this.loading = true;
    //this.modNew = false;
    this.DevelopmentRequestService.getDevReq(this.page, this.per_page, this.sort, query, filters).toPromise().then(
      response => {
        this.loading = false;
        this.edit(response.json().data[0]);
      },
      error => {
        this.loading = false;
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'No se puede realizar esta acción' } );
      }
    );
  }

  public showExportDialog() {
    this.modExportDialog = true;
  }

  public cancelExport() {
    this.modExportDialog = false;
  }

  public exportReportExcel(values) {
    let d = new Date(values.f4_date_start);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);

    const f4_date_start = formatDate(d);

    d = new Date(values.f4_date_end);
    d.setHours(23);
    d.setMinutes(59);
    d.setSeconds(59);
    d.setMilliseconds(59);
    const f4_date_end = formatDate(d);

    let url = this.apiUrl + '/development-requests/excel?' +
    'token=' + localStorage.getItem('token') +
    '&_page=1&_limit=100000&_sort=id&';

    if (f4_date_start) {
      url = url + 'created_at-min=' + f4_date_start + '&';
    }

    if (f4_date_end) {
      url = url + 'created_at-max=' + f4_date_end + '&';
    }

    if (values.f4_venue_id) {
      url = url + 'venue_id-in=' + values.f4_venue_id + '&';
    }

    if (values.f4_status_filter !== 'all' && values.f4_status_filter !== '') {
      url = url + 'status-in=' + values.f4_status_filter + '&';
    }
    window.open(url, '_blank');
  }

  getDiffDate(date_start, date_end?) {
    date_start = new Date(date_start);

    if (date_end == '' || date_end == null || date_end == undefined)
      date_end = new Date();
    else
      date_end = new Date(date_end);

    const diff = date_end.getTime() - date_start.getTime();  //msec
    return Math.ceil(diff / (1000 * 3600 * 24));
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/development-requests/development-requests.component.ts